var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group"},_vm._l((_vm.config),function(ref,index){
var id = ref.id;
var icon = ref.icon;
return _c('icon-button',{key:index,staticClass:"navigation-button",attrs:{"active":_vm.isButtonActive(id),"icon":icon,"is-button-group":true},on:{"click":function($event){return _vm.onChange(id)}}},[_c('span',{staticClass:"btn-text"},[_vm._v(" "+_vm._s(_vm.capitalize(id))+" ")])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }